import React, { useState, useEffect, useRef, useContext } from "react";
import "./TheMarket.css";
import { Container, Col, Row } from "react-bootstrap";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import MarketImg from "../../../Images/crack-market/crack-the-Market.png";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState } from '../../features/User/UserSlice';
function TheMarket() {
  const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const {  isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

         //   console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);

    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
              "/research",
                '_blank' // <- This is what makes it open in a new window.
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
  return (
    <>
      <section className="the-market-section">
        <Container className="add-border">
          <Row>
            <Col md={6}>
              <h2>
                <span>Crack the Markets</span>
              </h2>
              <p>
                Access detailed research reports and short term/long term
                trading ideas/ fundamental Research from our dedicated research
                team. Get trading ideas on your WhatsApp.
              </p>
               <a onClick={() => clickToggleLoginPopup(true)}  class="readMore" style={{cursor:"pointer"}}>Know More</a>
                {/* <ReadMore name="Know" /> */}
            </Col>
            <Col md={6}>
              <img
                className="img-fluid market-img"
                src={MarketImg}
                alt="MarketImg"
              />
            </Col>
          </Row>
          <LoginPopup show={show} ref={childRef} />
        </Container>
      </section>
    </>
  );
}
export default TheMarket;
